import JSON5 from 'json5'
import { GCLASSROOM_STUDENT_WORK } from '@mote/helpers/constants'
import { getApplicationView } from '../../helpers/getApplicationView'

export function getBasicClassroomInfo() {
  const isStudentWorkView = getApplicationView() === GCLASSROOM_STUDENT_WORK

  try {
    return {
      className: getClassName(isStudentWorkView),
      studentName: getStudentName(isStudentWorkView),
      assignmentName: document.title
    }
  } catch (e) {
    // error('Could not scrape basic Classroom information!', e)
    return {}
  }
}

function getClassName(isStudentWorkView) {
  if (isStudentWorkView) {
    return document.querySelector('nav a span').textContent
  }

  const scripts = document.querySelectorAll('script')

  const targetScript = Array.from(scripts).find(e =>
    e.outerHTML.includes('"classroom"')
  )

  const scriptContents = targetScript.innerHTML
  const firstBracket = scriptContents.indexOf('{')
  const lastBracket = scriptContents.lastIndexOf('}')
  const rawData = scriptContents.substring(firstBracket, lastBracket + 1)
  const dataJSON = JSON5.parse(rawData)

  return dataJSON.data[0][2]
}

function getStudentName(isStudentWorkView) {
  if (isStudentWorkView) {
    const pathname = new URL(document.URL).pathname.split('/')
    const referenceIndex = pathname.indexOf('student')
    const studentId = pathname[referenceIndex + 1]

    return Array.from(document.querySelectorAll('[href]'))
      .filter(item => item.href.includes(studentId))
      .find(item => !item.children.length).textContent
  }

  const parentElements = Array.from(document.querySelectorAll('c-wiz'))

  const targetStudent = parentElements.map(e => {
    const selectedStudent = e.querySelector('[aria-checked="true"]')
    return selectedStudent ? selectedStudent.querySelector('img') : ''
  })[0]

  return targetStudent.nextSibling.textContent
}
